module.exports = __webpack_public_path__ + "static/media/29BDOS11.e03a66e6.jpg";